import { render, staticRenderFns } from "./UserSettingsPayment.vue?vue&type=template&id=3db4e9d5"
import script from "./UserSettingsPayment.vue?vue&type=script&lang=js"
export * from "./UserSettingsPayment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports